import { ProductImageVariantVersions } from '@leid/api-products'

import { ImageType, Product } from 'appTypes/items'

export const getProductImageUrl = (product: Product): string => {
  let imageUrl = ''

  if (product.image) {
    imageUrl = product.image
  } else {
    const sortedImages = product.images?.sort((a: ImageType, b: ImageType) => a.id - b.id)

    imageUrl = (sortedImages && sortedImages[0]?.url) || ''
  }

  return imageUrl
}

export const getImageUrl = (images: ImageType[]): string => {
  const sortedImages = images?.sort((a: ImageType, b: ImageType) => a.id - b.id)
  return (sortedImages && sortedImages[0]?.url) || ''
}

export const getProductImageThumbnailUrl = (
  originalImageUrl: string,
  productImageVersions: ProductImageVariantVersions[] | undefined,
  type: 'thumbnail' | 'medium' | 'preview',
): string => {
  const orig = originalImageUrl || ''

  const origPureFilename = orig.substring(orig.lastIndexOf('/') + 1, orig.lastIndexOf('.'))

  let imageUrl = ''
  const foundUrl = productImageVersions?.find((version) => version?.cdn?.[type]?.includes(origPureFilename))

  const typedUrl = foundUrl?.cdn?.[type] || ''
  if (typedUrl) {
    imageUrl = typedUrl
  } else {
    imageUrl = originalImageUrl
  }
  return imageUrl
}
